import { colors, font, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
import { borderRadius } from '../../../externals';
export var SLIDE_TRANSITION_INTERVAL = 400; // TODO review non fanta colors

export var COLOR_SECONDARY_LIGHT = '#21a29d';
export var COLOR_SECONDARY_DARK = '#188e87';
export var Container = styled.div.withConfig({
  componentId: "sc-1fs8rei-0"
})(["overflow-x:hidden;position:relative;"]);
export var ControlWrapper = styled.div.withConfig({
  componentId: "sc-1fs8rei-1"
})(["display:flex;justify-content:space-between;padding:1.375rem;padding-left:2.125rem;"]);
export var ElementsList = styled.div.withConfig({
  componentId: "sc-1fs8rei-2"
})(["display:flex;height:100%;list-style:none;margin:0;padding:0;", " transition:transform ", "ms ease-in-out;"], function (_ref) {
  var currentSlide = _ref.currentSlide;
  return "transform: translateX(-".concat(currentSlide * 100, "%);");
}, SLIDE_TRANSITION_INTERVAL);
export var ListItem = styled.div.withConfig({
  componentId: "sc-1fs8rei-3"
})(["flex:1 0 100%;visibility:", ";order:", ";"], function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref3) {
  var order = _ref3.order;
  return order;
});
export var NextDoneButton = styled.button.withConfig({
  componentId: "sc-1fs8rei-4"
})(["cursor:pointer;height:2.75rem;line-height:2.68rem;border-radius:", ";font-size:", ";padding:0 ", ";border:2px solid ", ";background-color:", ";color:", ";font-family:", ";font-weight:", ";min-width:6.25rem;&:active{border-color:", ";background-color:", ";transform:translateY(2px);}"], borderRadius.large, font.size.px20, spacing.px24, COLOR_SECONDARY_LIGHT, COLOR_SECONDARY_LIGHT, colors.white, font.family["default"], font.weight.bold, COLOR_SECONDARY_DARK, COLOR_SECONDARY_DARK);